export * from './src/receipts-v1-receipts-settings-receipts-settings.schemas.js';
